import {
  useCatalogue,
  StoreMetadata,
  useStoreImages,
} from "@commons-monorepo/index";

const SchemaGraph = ({ storeMetadata }: { storeMetadata: StoreMetadata }) => {
  const { urlCatalogue } = useCatalogue({ storeMetadata });
  const { partnerProfilePicture } = useStoreImages(storeMetadata);
  const activeAddress = null;
  const partner = storeMetadata;

  return (
    <>
      <script
        type='application/ld+json'
        className='yoast-schema-graph'
        dangerouslySetInnerHTML={{
          __html: `
                    {
                        "@context": "https://schema.org",
                        "@type": "Store",
                        "name": "${storeMetadata?.enterpriseName}",
                        "address": ${
                          activeAddress
                            ? `{
                            "@type": "PostalAddress",
                            "streetAddress": ${
                              !!activeAddress?.address
                                ? `"${activeAddress?.address}"`
                                : '""'
                            },
                            "addressLocality": ${
                              !!activeAddress?.city
                                ? `"${activeAddress?.city}"`
                                : '""'
                            },
                            "postalCode": ${
                              !!activeAddress?.postalCode
                                ? `"${activeAddress?.postalCode}"`
                                : '""'
                            },
                            "addressCountry": ${
                              !!partner?.country ? `"${partner.country}"` : '""'
                            }  
                        }`
                            : '""'
                        },
                        "image": ${partnerProfilePicture},
                        "geo": ${
                          !!activeAddress?.lat && !!activeAddress.lng
                            ? `{
                            "@type": "GeoCoordinates",
                            "latitude": ${activeAddress?.lat},
                            "longitude": ${activeAddress.lng}
                        }`
                            : '""'
                        },
                        "url": "${urlCatalogue()}",
                        "telephone": ${
                          !!storeMetadata?.phone
                            ? `"${storeMetadata.prefixPhone}${storeMetadata?.phone}"`
                            : '""'
                        }
                      }
				`,
        }}
      />
    </>
  );
};

export default SchemaGraph;
